import http from "src/common/http";
import {DEVELOPMENT_URL,GET_ALL_CUSTOMERS, GET_CUSTOMER_DETAIL} from "../constants/apiUrl";

const allCustomers = (page) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_ALL_CUSTOMERS+page, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
       
        return response;
      })
  };


  const getCustomerDetail = (customerId) => {
    const user = window.sessionStorage.getItem('token');
    
    return http
      .get(DEVELOPMENT_URL + GET_CUSTOMER_DETAIL+customerId, {
        headers: {
            'authorization': `Bearer ${user}`,
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
      })
      .then((response) => {
    
        return response;
      })
  };

  
  export default {allCustomers, getCustomerDetail};